import { useEffect, useState } from "react";
import { fetchPropertyDetails } from "../../api-client";
import Loader from "../LoaderComponent";
import { PropertyRoom, Deal } from "../../../../backend/src/models/getPropertyAvailability";
import { Accommodation, PropertyDetails } from "../../../../backend/src/models/getPropertyDetails";

interface RoomDetailsModalProps {
    room: PropertyRoom;
    deal: Deal;
    onClose: () => void;
    hotelName: string;
    hotelId: string;
    destinationCode: string;
}
const RoomDetailsModal: React.FC<RoomDetailsModalProps> = ({onClose, room, hotelId, destinationCode}) => {
    const [error, setError] = useState<string>('');
    const [propertyDetails, setHotelDetails] = useState<PropertyDetails | null>(null);

    useEffect(() => {
        getPropertyDetails();
      }, [hotelId]);

    const getPropertyDetails = async () => {
        try {
          const data = await fetchPropertyDetails(destinationCode, hotelId);
          setHotelDetails(data as PropertyDetails);
        } catch (error: any) {
          setError(error.message);
        }
    }

    if (error) {
        return <div>Error: {error}</div>;
    }

    if (!propertyDetails) {
        return <Loader />;
    }
    
    const getMatchingAccommodationImage = (): string | null => {
        if (!propertyDetails) return null;
    
        const matchedAccommodation: Accommodation | undefined = propertyDetails.accommodations.find(
          (accommodation) => accommodation.code === room.code && accommodation.name === room.name
        );
    
        return matchedAccommodation?.featuredImage || null;
      };

    const featuredImage = getMatchingAccommodationImage();

    // const getMatchingAccommodation = (): Accommodation | null => {
    //     if (!propertyDetails) return null;

    //     const matchedAccommodation: Accommodation | undefined = propertyDetails.accommodations.find(
    //         (accommodation) => accommodation.code === room.code && accommodation.name === room.name
    //     );

    //     return matchedAccommodation || null;
    // };

    // const matchedAccommodation = getMatchingAccommodation();

    // const getAmenities = (): Amenity[] => {
    //     return matchedAccommodation ? matchedAccommodation.amenities : [];
    // };

    // const amenities = getAmenities();


    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="fixed inset-0 bg-black bg-opacity-50"></div>
          <div className="relative bg-white rounded-lg shadow-lg md:w-[40%] 2xl:w-[30%] md:h-[65%] 2xl:h-[42%] overflow-auto p-6 scrollbar-initial max-w-full max-h-full">
            <button className="absolute top-2 right-2 text-gray-500 hover:text-gray-700" onClick={onClose}>
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
      
            {/* <div className="text-xl font-bold text-center mb-1">{hotelName}</div> */}
            <p className="text-xl font-bold text-center mb-4">
              {room.name.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase())}
            </p>
      
            {/* Flex container for the image and facilities */}
            <div className="flex flex-col lg:flex-row gap-6 justify-center items-center">
              {/* Room Image */}
              {featuredImage && featuredImage.length > 0 ? (
                <div className="relative w-full md:w-[80%] 2xl:w-[90%] h-[250px] md:h-[275px] 2xl:h-[290px] overflow-hidden">
                  <div className="flex h-full">
                    <img
                      key={`photo-${room.name}`}
                      src={featuredImage}
                      alt={`Room Photo ${room.name}`}
                      className="w-full h-full object-cover transition-transform duration-300 transform scale-105 px-2 rounded-lg"
                    />
                  </div>
                </div>
              ) : (
                <div className="lg:w-1/2 px-4 md:px-8">
                  <div className="text-center p-4 bg-pink-200 border border-halo-pink rounded-lg text-black mt-8">
                    No photos available
                  </div>
                  <div className="flex justify-center bg-[#e9eef2] md:p-16 2xl:p-28 rounded-lg mt-4">
                    <img className="h-[150px] md:h-[200px]" src="/no-photo.png" alt="No Photo" />
                  </div>
                </div>
              )}
      
              {/* Room Facilities
              <div className="lg:w-1/2">
                <div className="mt-6 lg:mt-0">
                  <div className="text-md font-semibold mb-2">
                    {amenities.length > 0 ? 'Room Facilities' : ''}
                  </div>
                  {amenities.length > 0 ? (
                  <ul className="list-none space-y-2">
                    {amenities.map((amenity, amenityIndex) => (
                      <li key={amenityIndex} className="flex items-center text-gray-600">
                        <span className="text-green-500 mr-2">✔</span>
                        <span>{amenity.name}</span>
                      </li>
                    ))}
                  </ul>
                  ) : (
                    <div className="text-center p-4 bg-pink-200 border border-halo-pink rounded-lg text-black">
                        No details available
                    </div>
                  )}
                </div>
              </div> */}
            </div>
          </div>
        </div>
      );
      
}

export default RoomDetailsModal;